import React from 'react'
import styles from './InviteWidget.scss'
import { Map } from 'immutable'
import { connect } from 'react-redux'
import { loadFriends } from 'lib/api/currentUser'
import { photoMilli } from 'lib/urlHelpers'
import { FancyCheckbox } from 'common/FancyCheckbox'
import { CTA } from 'common/styleguide/CTA'
import { Icon } from 'common/Icon'
import { ModalOverlay } from 'common/styleguide/ModalOverlay'
import { TwoCTAFooter } from 'common/styleguide/Modal'
import base from 'lib/styleguide/base.scss'
import cx from 'classnames'

const alphaSort = (a, b) => {
  const A = a.toUpperCase()
  const B = b.toUpperCase()
  if (A < B) return -1
  if (B > A) return 1
  return 0
}

export class InviteWidget extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      toInvite: Map()
    }
  }

  componentDidMount () {
    this.props.loadFriends()
  }

  toggleFriend = (friend) => {
    const { toInvite } = this.state
    if (toInvite.get(friend.get('id'))) {
      this.setState({
        toInvite: toInvite.delete(friend.get('id'))
      })
    } else {
      this.setState({
        toInvite: toInvite.set(friend.get('id'), friend)
      })
    }
  }

  confirmInvites = () => {
    const { onConfirmInvites } = this.props
    const { toInvite } = this.state
    onConfirmInvites(toInvite)
  }

  render () {
    const { friends, onRequestClose, invited, inviteLink } = this.props
    const { toInvite } = this.state

    const sortInvitedThenName = (a, b) => {
      // if both have same invite status, sort alphabetically
      const aInvited = invited.find(gp => gp.getIn(['user', 'id']) === a.get('id'))
      const bInvited = invited.find(gp => gp.getIn(['user', 'id']) === b.get('id'))
      if (aInvited === bInvited) return alphaSort(a.get('name'), b.get('name'))
      if (aInvited) return 1
      if (bInvited) return -1
    }

    const footer = <TwoCTAFooter>
      <a onClick={onRequestClose}>Cancel</a>
      <CTA inline margins={false} onClick={this.confirmInvites}>Send Invites</CTA>
    </TwoCTAFooter>

    return (
      <ModalOverlay
        contentPadding={false}
        maxWidth='800px'
        onRequestClose={onRequestClose}
        footer={footer}
        theme={{ inner: styles.modalInner }}
        title='Invite Friends'>
        <div className={styles.InviteWidget}>
          {/* fixed headings */}
          <div className={styles.headingContainer}>
            <div className={styles.left}>
              <div className={cx(base.contentLabel, styles.colHead)}>Friends ({friends.size})</div>
            </div>
            <div className={styles.right}>
              <div className={cx(base.contentLabel, styles.colHead)}>Selected ({toInvite.size})</div>
            </div>
          </div>
          <div className={styles.scrollContainer}>
            <div className={styles.left}>
              {friends.toIndexedSeq().sort(sortInvitedThenName).map(f => <FriendRow key={f.get('id')}
                selected={toInvite.has(f.get('id'))}
                invited={invited.find(gp => gp.getIn(['user', 'id']) === f.get('id'))}
                friend={f}
                onToggleSelection={this.toggleFriend} />)}
            </div>
            <div className={styles.right}>
              {toInvite.toIndexedSeq().sortBy(f => f.get('name').toUpperCase()).map(f => <InviteRow key={f.get('id')} friend={f} onRemove={this.toggleFriend} />)}
            </div>
          </div>
          {inviteLink &&
          <div className={styles.inviteLink}>
            <form onSubmit={() => {}}>
              <label>Anyone with this link can view and join the goal:</label>
              <input type='text' readOnly value={inviteLink} onClick={e => e.target.select()} />
            </form>
          </div>}
        </div>
      </ModalOverlay>
    )
  }
}

const FriendRow = ({ friend, invited, selected, onToggleSelection }) => {
  const className = cx(
    styles.friendRow,
    selected && styles.friendRowSelected,
    invited && styles.friendRowInvited
  )
  return (
    <div className={className} onClick={!invited && (() => onToggleSelection(friend))}>
      <img src={photoMilli(friend.get('highlighted_photo_id'))} className={styles.friendImg} />
      <div>
        <div className={styles.friendName}>{friend.get('name')}</div>
        {invited && <div className={styles.friendStatus}>invited</div>}
      </div>
      <div className={styles.checkboxHere}>
        <FancyCheckbox className={styles.checkbox} selected={selected} />
      </div>
    </div>
  )
}

const InviteRow = ({ friend, onRemove }) => {
  return (
    <div className={styles.InviteRow}>
      <div className={styles.friendName}>{friend.get('name')}</div>
      <div className={styles.removeIcon} onClick={() => onRemove(friend)}>
        <Icon i='ios-close-circle-outline' size={18} />
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  friends: state.currentUser.friends.get('records'),
  friendsLoaded: state.currentUser.friends.get('loadStatus')
})

const mapDispatchToProps = {
  loadFriends
}

export const InviteWidgetContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(InviteWidget)
